import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';

import moment from 'moment';

import ReportPeriod from './ReportPeriod';
import ReportHolding from './ReportHolding';
import ReportOperate from './ReportOperate';
import ReportEvent from './ReportEvent';
import ReportCalibrate from './ReportCalibrate';

import * as reportCss from './DetailReport.css.js';

const DetailReport = ({ searchMap, reportMap, setReportMap }) => {
  const cancellationToken = useCancellationToken();
  const auths = useSelector((state) => state.auths.auth).filter(d => d.level === 2);
  const [beginDate, endDate] = [moment(searchMap.beginDate).format('YYYY-MM-DDTHH:mm:ssZ'),
  moment(searchMap.endDate).format('YYYY-MM-DDTHH:mm:ssZ')];

  useEffect(() => {
    setReportMap(reportMap => {
      return {
        ...reportMap,
        'period': {
          ...reportMap.period,
          begin: moment(beginDate).format('YYYY-MM-DD'),
          end: moment(endDate).format('YYYY-MM-DD')
        }
      }
    })
  }, [beginDate, endDate])

  useEffect(() => {
    setReportMap(reportMap => {
      return {
        ...reportMap,
        'auths': [...auths]
      }
    })
  }, [])

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <reportCss.DetailReportContainer>
      <reportCss.TitleBar>UBiTOMS™ REPORT</reportCss.TitleBar>
      <ReportPeriod reportMap={reportMap} setReportMap={setReportMap} beginDate={beginDate} endDate={endDate} />
      <ReportHolding setReportMap={setReportMap} auths={auths} beginDate={beginDate} endDate={endDate} />
      <ReportOperate setReportMap={setReportMap} auths={auths} beginDate={beginDate} endDate={endDate} />
      <ReportEvent setReportMap={setReportMap} auths={auths} beginDate={beginDate} endDate={endDate} />
      <ReportCalibrate setReportMap={setReportMap} beginDate={beginDate} endDate={endDate} />
    </reportCss.DetailReportContainer>
  )
}

export default DetailReport;